// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__3kvEY","box":"Contact_box__2S_Fb","row":"Contact_row__2_abb"};